module.exports = __webpack_public_path__ + "img/x-circle-red.0c9b8c9b.svg";